<script>
import Ajax from "@vvg/forum/js/mixins/ajax";
export default {
	emits: ['update:loading', 'update:items'],
	mixins: [Ajax],

	props: {
		ajaxData: {
			type: Object,
			required: false,
			default: {}
		},
		route: {
			type: String,
			required: true
		},
		perPage: {
			type: [Number, String],
			required: true
		},
		prevNext: {
			type: Boolean,
			required: false,
			default: true
		},
		currentPage: {
			type: [Number, String],
			required: false,
			default: 1
		}
	},

	data() {
		return {
			page: this.$props.currentPage,
			pages: 0,
			total: 0,
		}
	},

	methods: {
		getItems() {
			this.$emit('update:loading', 1);

			let data = Object.assign({
				start: this.perPage * (this.page - 1),
				length: this.perPage,
			}, this.ajaxData);

			this.Ajax(this.route, 'GET', data).then(response => {
				this.total = response.recordsFiltered;
				this.pages = Math.ceil(this.total / this.perPage);

				this.$emit('update:loading', 0);
				this.$emit('update:items', {
					response: response,
					items: response.data,
					pages: this.pages,
					currentPage: this.page
				});
			});
		},
		changePage(page) {
			this.page = page;
			this.getItems();
		},

		pushNumberIfPossible(numbers, number) {
			if (numbers.includes(number)) {
				return numbers;
			}
			if (number > this.pages || number <= 0) {
				return numbers;
			}
			numbers.push(number);
			return numbers;
		}
	},

	mounted() {
		this.getItems();
	},

	computed: {
		numbers() {
			let numbers = [];
			if (this.pages <= 9) {
				for (let i = 1; i <= this.pages; i++) {
					numbers.push(i);
				}
				return numbers;
			}

			let pushDotsFirst = false;
			let pushDotsSecond = false;

			numbers = this.pushNumberIfPossible(numbers, 1);
			numbers = this.pushNumberIfPossible(numbers, 2);

			if (this.page >= 6) {
				pushDotsFirst = true;
				numbers = this.pushNumberIfPossible(numbers, this.page - 1);
				numbers = this.pushNumberIfPossible(numbers, this.page);
				numbers = this.pushNumberIfPossible(numbers, this.page + 1);
			} else {
				numbers = this.pushNumberIfPossible(numbers, 3);
				numbers = this.pushNumberIfPossible(numbers, 4);
				numbers = this.pushNumberIfPossible(numbers, 5);
				numbers = this.pushNumberIfPossible(numbers, 6);
			}

			if (this.page <= (this.pages - 5) && this.pages > 6) {
				pushDotsSecond = true;
				numbers = this.pushNumberIfPossible(numbers, this.pages - 1);
				numbers = this.pushNumberIfPossible(numbers, this.pages);
			} else {
				for (let number = this.pages - 5; number <= this.pages; number++) {
					numbers = this.pushNumberIfPossible(numbers, number);
				}
			}

			// Yuk bah js (sorteren van nummers)
			numbers.sort((a, b) => a - b);
			if (pushDotsFirst) {
				numbers.splice(2, 0, '...');
			}
			if (pushDotsSecond) {
				numbers.splice(numbers.length - 2, 0, '...');
			}

			return numbers;
		},
	}
}
</script>

<template>
	<div v-bind="$attrs">
		<ul class="pagination mb-0" v-if="pages > 1">
			<li v-if="prevNext" class="page-item" :class="{'disabled' : page <= 1}">
				<a class="page-link" href="javascript:void(0);" @click="changePage(page - 1)">
					<i class="fas fa-arrow-left"></i>
				</a>
			</li>

			<li class="page-item" v-for="number in numbers" :class="{'active' : number === page}">
				<span class="page-link" v-if="number === '...'">{{ number }}</span>
				<a v-if="number !== '...'" class="page-link" href="javascript:void(0);" @click="changePage(number)">{{ number }}</a>
			</li>

			<li v-if="prevNext" class="page-item" :class="{'disabled' : page >= pages}">
				<a class="page-link" href="javascript:void(0);" @click="changePage(page + 1)">
					<i class="fas fa-arrow-right"></i>
				</a>
			</li>
		</ul>
	</div>
</template>